import { getConfiguration } from '../api/config';
import * as api from '../api/global';
import {
  makeApiActionCreator,
  getOfficeFromUrl,
  createRequestTypes,
  START,
  SUCCESS,
  ERROR
} from './utils';
import { userTypes } from '../constants';
import { apiBaseUrlSelector } from '../selectors/global';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const LOGOUT = 'LOGOUT';

export const SEARCH_CONFIG_FETCH_START = 'GLOBAL/SEARCH_CONFIG_FETCH_START';
export const SEARCH_CONFIG_FETCH_SUCCESS = 'GLOBAL/SEARCH_CONFIG_FETCH_SUCCESS';
export const SEARCH_CONFIG_FETCH_ERROR = 'GLOBAL/SEARCH_CONFIG_FETCH_ERROR';

export const SEARCH_RESULT_CONFIG_FETCH_START =
  'GLOBAL/SEARCH_RESULT_CONFIG_FETCH_START';
export const SEARCH_RESULT_CONFIG_FETCH_SUCCESS =
  'GLOBAL/SEARCH_RESULT_CONFIG_FETCH_SUCCESS';
export const SEARCH_RESULT_CONFIG_FETCH_ERROR =
  'GLOBAL/SEARCH_RESULT_CONFIG_FETCH_ERROR';

export const SEARCH_START = 'GLOBAL/SEARCH_START';
export const SEARCH_SUCCESS = 'GLOBAL/SEARCH_SUCCESS';
export const SEARCH_ERROR = 'GLOBAL/SEARCH_ERROR';

export const FETCH_CURRENT_YEAR = createRequestTypes(
  'GLOBAL/FETCH_CURRENT_YEAR'
);

export const PROPERTY_FETCH_START = 'GLOBAL/PROPERTY_FETCH_START';
export const PROPERTY_FETCH_SUCCESS = 'GLOBAL/PROPERTY_FETCH_SUCCESS';
export const PROPERTY_FETCH_ERROR = 'GLOBAL/PROPERTY_FETCH_ERROR';

export const CONFIG_FETCH_START = 'GLOBAL/CONFIG_FETCH_START';
export const CONFIG_FETCH_SUCCESS = 'GLOBAL/CONFIG_FETCH_SUCCESS';
export const CONFIG_FETCH_ERROR = 'GLOBAL/CONFIG_FETCH_ERROR';

export const HEARING_OPEN_START = 'GLOBAL/HEARING_OPEN_START';
export const HEARING_OPEN_SUCCESS = 'GLOBAL/HEARING_OPEN_SUCCESS';
export const HEARING_OPEN_ERROR = 'GLOBAL/HEARING_OPEN_ERROR';

export const TAXING_UNIT_FETCH_START = 'GLOBAL/TAXING_UNIT_FETCH_START';
export const TAXING_UNIT_FETCH_SUCCESS = 'GLOBAL/TAXING_UNIT_FETCH_SUCCESS';
export const TAXING_UNIT_FETCH_ERROR = 'GLOBAL/TAXING_UNIT_FETCH_ERROR';

export const CHANGE_CURRENT_PAGE = 'GLOBAL/CHANGE_CURRENT_PAGE';
export const CHANGE_SORT_MODEL = 'GLOBAL/CHANGE_SORT_MODEL';
export const CHANGE_PAGE_SIZE = 'GLOBAL/CHANGE_PAGE_SIZE';
export const CHANGE_QUERY_STRING = 'GLOBAL/CHANGE_QUERY_STRING';

export const ETR_PDF_FETCH_START = 'GLOBAL/ETR_PDF_FETCH_START';
export const ETR_PDF_FETCH_SUCCESS = 'GLOBAL/ETR_PDF_FETCH_SUCCESS';
export const ETR_PDF_FETCH_ERROR = 'GLOBAL/ETR_PDF_FETCH_ERROR';

export const PROPOSED_PDF_FETCH_START = 'GLOBAL/PROPOSED_PDF_FETCH_START';
export const PROPOSED_PDF_FETCH_SUCCESS = 'GLOBAL/PROPOSED_PDF_FETCH_SUCCESS';
export const PROPOSED_PDF_FETCH_ERROR = 'GLOBAL/PROPOSED_PDF_FETCH_ERROR';

export const VOTER_PDF_FETCH_START = 'GLOBAL/VOTER_PDF_FETCH_START';
export const VOTER_PDF_FETCH_SUCCESS = 'GLOBAL/VOTER_PDF_FETCH_SUCCESS';
export const VOTER_PDF_FETCH_ERROR = 'GLOBAL/VOTER_PDF_FETCH_ERROR';

export const ADOPTED_PDF_FETCH_START = 'GLOBAL/ADOPTED_PDF_FETCH_START';
export const ADOPTED_PDF_FETCH_SUCCESS = 'GLOBAL/ADOPTED_PDF_FETCH_SUCCESS';
export const ADOPTED_PDF_FETCH_ERROR = 'GLOBAL/ADOPTED_PDF_FETCH_ERROR';

export const BUDGET_PDF_FETCH_START = 'GLOBAL/BUDGET_PDF_FETCH_START';
export const BUDGET_PDF_FETCH_SUCCESS = 'GLOBAL/BUDGET_PDF_FETCH_SUCCESS';
export const BUDGET_PDF_FETCH_ERROR = 'GLOBAL/BUDGET_PDF_FETCH_ERROR';

export const ELECTION_PDF_FETCH_START = 'GLOBAL/ELECTION_PDF_FETCH_START';
export const ELECTION_PDF_FETCH_SUCCESS = 'GLOBAL/ELECTION_PDF_FETCH_SUCCESS';
export const ELECTION_PDF_FETCH_ERROR = 'GLOBAL/ELECTION_PDF_FETCH_ERROR';

export const TOKEN_FETCH_START = 'GLOBAL/TOKEN_FETCH_START';
export const TOKEN_FETCH_SUCCESS = 'GLOBAL/TOKEN_FETCH_SUCCESS';
export const TOKEN_FETCH_ERROR = 'GLOBAL/TOKEN_FETCH_ERROR';

export const HISTORICAL_RATES_FETCH_START = 'GLOBAL/HISTORICAL_RATES_FETCH_START';
export const HISTORICAL_RATES_FETCH_SUCCESS = 'GLOBAL/HISTORICAL_RATES_FETCH_SUCCESS';
export const HISTORICAL_RATES_FETCH_ERROR = 'GLOBAL/HISTORICAL_RATES_FETCH_ERROR';

export const GENERATE_REPORT_START = 'GLOBAL/GENERATE_REPORT_START';
export const GENERATE_REPORT_SUCCESS = 'GLOBAL/GENERATE_REPORT_SUCCESS';
export const GENERATE_REPORT_ERROR = 'GLOBAL/GENERATE_REPORT_ERROR';

export const CREATE_TAXING_UNIT_MESSAGE = createRequestTypes(
  'GLOBAL/CREATE_TAXING_UNIT_MESSAGE'
);
export const CONFIGURE = 'CONFIGURE';

export const FETCH_IMPORT_STATUS = createRequestTypes(
  'GLOBAL/FETCH_IMPORT_STATUS'
);

export const fetchToken = makeApiActionCreator(
  api.fetchToken,
  TOKEN_FETCH_START,
  TOKEN_FETCH_SUCCESS,
  TOKEN_FETCH_ERROR
);
export const fetchClientConfig = makeApiActionCreator(
  api.fetchClientConfig,
  CONFIG_FETCH_START,
  CONFIG_FETCH_SUCCESS,
  CONFIG_FETCH_ERROR
);
export const fetchSearchConfig = makeApiActionCreator(
  api.fetchSearchConfig,
  SEARCH_CONFIG_FETCH_START,
  SEARCH_CONFIG_FETCH_SUCCESS,
  SEARCH_CONFIG_FETCH_ERROR
);
export const fetchSearchResultConfig = makeApiActionCreator(
  api.fetchSearchResultConfig,
  SEARCH_RESULT_CONFIG_FETCH_START,
  SEARCH_RESULT_CONFIG_FETCH_SUCCESS,
  SEARCH_RESULT_CONFIG_FETCH_ERROR
);
export const fetchCurrentYear = makeApiActionCreator(
  api.fetchCurrentYear,
  FETCH_CURRENT_YEAR[START],
  FETCH_CURRENT_YEAR[SUCCESS],
  FETCH_CURRENT_YEAR[ERROR]
);
export const fetchProperty = makeApiActionCreator(
  api.fetchProperty,
  PROPERTY_FETCH_START,
  PROPERTY_FETCH_SUCCESS,
  PROPERTY_FETCH_ERROR
);
export const search = makeApiActionCreator(
  api.search,
  SEARCH_START,
  SEARCH_SUCCESS,
  SEARCH_ERROR
);
export const openHearing = makeApiActionCreator(
  api.openHearing,
  HEARING_OPEN_START,
  HEARING_OPEN_SUCCESS,
  HEARING_OPEN_ERROR
);
export const fetchTaxingUnit = makeApiActionCreator(
  api.fetchTaxingUnit,
  TAXING_UNIT_FETCH_START,
  TAXING_UNIT_FETCH_SUCCESS,
  TAXING_UNIT_FETCH_ERROR
);
export const fetchETRPDF = makeApiActionCreator(
  api.fetchETRPDF,
  ETR_PDF_FETCH_START,
  ETR_PDF_FETCH_SUCCESS,
  ETR_PDF_FETCH_ERROR
);
export const fetchVoterPDF = makeApiActionCreator(
  api.fetchVoterPDF,
  VOTER_PDF_FETCH_START,
  VOTER_PDF_FETCH_SUCCESS,
  VOTER_PDF_FETCH_ERROR
);
export const fetchProposedPDF = makeApiActionCreator(
  api.fetchProposedPDF,
  PROPOSED_PDF_FETCH_START,
  PROPOSED_PDF_FETCH_SUCCESS,
  PROPOSED_PDF_FETCH_ERROR
);
export const fetchAdoptedPDF = makeApiActionCreator(
  api.fetchAdoptedPDF,
  ADOPTED_PDF_FETCH_START,
  ADOPTED_PDF_FETCH_SUCCESS,
  ADOPTED_PDF_FETCH_ERROR
);
export const fetchBudgetPDF = makeApiActionCreator(
  api.fetchBudgetPDF,
  BUDGET_PDF_FETCH_START,
  BUDGET_PDF_FETCH_SUCCESS,
  BUDGET_PDF_FETCH_ERROR
);
export const fetchElectionPDF = makeApiActionCreator(
  api.fetchElectionPDF,
  ELECTION_PDF_FETCH_START,
  ELECTION_PDF_FETCH_SUCCESS,
  ELECTION_PDF_FETCH_ERROR
);
export const createTaxingUnitMessage = makeApiActionCreator(
  api.createTaxingUnitMessage,
  CREATE_TAXING_UNIT_MESSAGE[START],
  CREATE_TAXING_UNIT_MESSAGE[SUCCESS],
  CREATE_TAXING_UNIT_MESSAGE[ERROR]
);

export const fetchImportStatus = makeApiActionCreator(
  api.fetchImportStatus,
  FETCH_IMPORT_STATUS[START],
  FETCH_IMPORT_STATUS[SUCCESS],
  FETCH_IMPORT_STATUS[ERROR]
);

export const fetchHistoricalRates = makeApiActionCreator(
  api.fetchHistoricalRates,
  HISTORICAL_RATES_FETCH_START,
  HISTORICAL_RATES_FETCH_SUCCESS,
  HISTORICAL_RATES_FETCH_ERROR
);

export const generateReport = makeApiActionCreator(
  api.generateReport,
  GENERATE_REPORT_START,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_ERROR,
);

export function loginToUserService ({ token }) {
  return async (dispatch, getState) => {
    dispatch({ type: LOGIN_START });
    try {
      const state = getState();
      const authUrl = apiBaseUrlSelector(state);
      const data = await api.loginToUserService(authUrl, token);

      if (data.error) {
        throw 'login failed';
      }
      if (
        data.user.userType !== userTypes.INTERNAL &&
        data.user.userType !== userTypes.PRIVATE
      ) {
        throw 'The userType must be "internal" or "private" to access the ProdigyUI site.';
      }

      dispatch({ data, type: LOGIN_SUCCESS });
      localStorage?.setItem('session', JSON.stringify(data));
      return data;
    } catch (error) {
      dispatch({ error, type: LOGIN_ERROR });
      throw error;
    }
  };
}

export function logout () {
  // clear session and auth0 entries from localStorage
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith('@@auth0') || key === 'session') {
      localStorage.removeItem(key);
    }
  }
  return { type: LOGOUT }; // clears user data from redux store
}

export function changeCurrentPage (page) {
  return async (dispatch, getState) => {
    dispatch({ type: CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel (model) {
  return async (dispatch, getState) => {
    dispatch({ type: CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize (page) {
  return async (dispatch, getState) => {
    dispatch({ type: CHANGE_PAGE_SIZE, data: page });
  };
}

export function changeQueryString (query) {
  return async (dispatch, getState) => {
    dispatch({ type: CHANGE_QUERY_STRING, data: query });
  };
}

export function init () {
  return async dispatch => {
    const configuration = await getConfiguration();
    const urlOffice = getOfficeFromUrl();
    if (urlOffice) {
      configuration.urls.office = urlOffice;
    }
    dispatch({ type: CONFIGURE, configuration });

    if (localStorage && localStorage.getItem('session')) {
      dispatch({
        type: LOGIN_SUCCESS,
        data: JSON.parse(localStorage.getItem('session'))
      });
    }
  };
}
